/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_DeletedInputs */

const en_admin_permissions_deleted = /** @type {(inputs: Admin_Permissions_DeletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission deleted`)
};

/**
* | output |
* | --- |
* | "Permission deleted" |
*
* @param {Admin_Permissions_DeletedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_deleted = /** @type {((inputs?: Admin_Permissions_DeletedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_DeletedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_deleted(inputs)
});
export { admin_permissions_deleted as "admin.permissions.deleted" }